<template>
  <div class="sh-blocked-notice">
    You’ve blocked this user.
    <a href="#" class="sh-blocked-notice-link" @click.prevent="confirmOpen = true">Unblock user</a>
    in order to see {{ what }}.
    <BlockUserConfirm :visible="confirmOpen" mode="unblock" @confirm="confirmUnblock" @cancel="confirmOpen = false" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BlockUserConfirm from "./BlockUserConfirm.vue";

// Gray bar that replaces the body of a post/comment whose author the viewer
// has blocked. Owns its own unblock confirmation so callers just swap the
// body for <BlockedContentNotice :user-id="..." what="the full post" />.
export default {
  name: "BlockedContentNotice",
  components: { BlockUserConfirm },
  props: {
    userId: { type: [Number, String], required: true },
    // "the full post" | "their comments"
    what: { type: String, default: "the full post" }
  },
  data() {
    return { confirmOpen: false };
  },
  methods: {
    ...mapActions("blockedUsers", ["unblockUser"]),
    confirmUnblock() {
      this.confirmOpen = false;
      this.unblockUser({ userId: this.userId });
    }
  }
};
</script>

<style scoped>
.sh-blocked-notice {
  background-color: #e6e8eb;
  color: #4a4f54;
  font-size: 15px;
  line-height: 1.5;
  padding: 14px 20px;
  border-radius: 4px;
  text-align: left;
  margin: 8px 0;
}

.sh-blocked-notice-link {
  color: #1a1a1a;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.sh-blocked-notice-link:hover {
  color: #008295;
}
</style>
